/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Pipe, PipeTransform } from '@angular/core';
import { createUomQuantity, GtoUom } from '@gh/builder-shared-data';
import { isNotNil } from '@gh/core-util';

@Pipe({
  name: 'uomQuantity',
  pure: true,
})
export class UomQuantityPipe implements PipeTransform {
  transform(value: Maybe<number>, uomCode: GtoUom): any {
    return isNotNil(value) ? createUomQuantity(value, uomCode) : void 0;
  }
}
